import { manufacturingFetch } from "@/lib/manufacturingClient";

export type ContractInstanceStatus =
  | "draft"
  | "sent"
  | "viewed"
  | "partially_signed"
  | "signed"
  | "declined"
  | "expired"
  | "voided";

export type SignerStatus = "pending" | "sent" | "viewed" | "signed" | "declined";

export type SignChannel = "email" | "sms" | "embedded";

export type ContractInstance = {
  id: string;
  organization_id: string;
  status: ContractInstanceStatus;
  envelope_id: string | null;
  signed_pdf_storage_path: string | null;
  signed_at: string | null;
  paperwork_item_key: string | null;
  deal_id: string | null;
  created_at: string;
  updated_at: string;
};

export type ContractSigner = {
  id: string;
  instance_id: string;
  role: string;
  channel: SignChannel;
  email: string | null;
  phone: string | null;
  provider_signer_id: string | null;
  status: SignerStatus;
  order_index: number;
};

export type SignInstanceGetResponse = {
  ok: true;
  instance: ContractInstance;
  signers: ContractSigner[];
};

export function getSignInstance(instanceId: string) {
  const q = new URLSearchParams({ instance_id: instanceId });
  return manufacturingFetch<SignInstanceGetResponse>(`/api/sign/instance-get?${q.toString()}`, {
    method: "GET",
  });
}

export function resendSignInstance(payload: { instance_id: string; signer_id: string }) {
  return manufacturingFetch<SignInstanceGetResponse>("/api/sign/instance-resend", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function voidSignInstance(payload: { instance_id: string; reason: string }) {
  return manufacturingFetch<SignInstanceGetResponse>("/api/sign/instance-void", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export type SignDocumentUrlResponse = {
  ok: true;
  signed_url: string;
  signed_expires_at: string;
  ttl_sec: number;
  object_path: string;
};

export function getSignDocumentUrl(instanceId: string) {
  const q = new URLSearchParams({ instance_id: instanceId });
  return manufacturingFetch<SignDocumentUrlResponse>(`/api/sign/document-url?${q.toString()}`, {
    method: "GET",
  });
}
